// core/services/loading.service.ts
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LOADER_DEFAULTS, LoaderDefaults } from '../interceptors/loader.tokens';

@Injectable({ providedIn: 'root' })
export class GlobalLoadingService {
  private defaults = inject<LoaderDefaults>(LOADER_DEFAULTS);


  private counter = 0;
  private showTimer: any = null;
  private hideTimer: any = null;
  private visibleSince = 0;
  private minVisibleMs = 0;

  private _loading$ = new BehaviorSubject<boolean>(false);
  loading$ = this._loading$.asObservable();

  private _label$ = new BehaviorSubject<string>('Attendere…');
  label$ = this._label$.asObservable();

  start(opts?: { label?: string }) {
    this.counter++;
    if (this.counter === 1) {
      const delay = Math.max(0, this.defaults.showDelayMs);
      this.minVisibleMs = Math.max(0, this.defaults.minVisibleMs);
      this._label$.next(opts?.label || 'Attendere…');

      clearTimeout(this.showTimer);
      this.showTimer = setTimeout(() => {
        if (this.counter > 0 && !this._loading$.value) {
          this.visibleSince = Date.now();
          this._loading$.next(true);
        }
      }, delay);
    }
  }

  stop() {
    if (this.counter === 0) return;
    this.counter--;
    if (this.counter === 0) {
      clearTimeout(this.showTimer);
      const elapsed = this.visibleSince ? Date.now() - this.visibleSince : 0;
      const wait = Math.max(0, this.minVisibleMs - elapsed);

      clearTimeout(this.hideTimer);
      this.hideTimer = setTimeout(() => {
        this._loading$.next(false);
        this._label$.next('Attendere…');
        this.visibleSince = 0;
        this.minVisibleMs = 0;
      }, wait);
    }
  }
}
